
class IsotopeGrid {
  constructor(element, ...options) {
    this.defaults = {
      itemSelector: '.js-isotope-item',
      masonry: {
        columnWidth: '.js-isotope-sizer',
      },
    };

    this.element = element;
    this.options = Object.assign({}, this.defaults, ...options);

    this.init();
  }

  init() {
    this.sortCats = this.element.dataset.sort || false;

    if (this.sortCats) {
      this.addSortParams();
    }

    this.iso = new Isotope(this.element, this.options);
  }

  addSortParams() {
    const sortOptions = { getSortData: {}, sortBy: '' };
    const sortCatsArray = this.sortCats.split(', ');

    sortCatsArray.forEach((cat) => {
      sortOptions.getSortData[cat] = `[data-${cat}]`;
    });
    sortOptions.sortBy = sortCatsArray;

    this.options = Object.assign({}, this.options, sortOptions);
  }
}
